var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { isGlobalAdmin } from "@irati/identity/helpers/user/role";
import { TeamState } from "@irati/types";
import { H3 } from "@irati/ui/src/Headings";
import Button from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import { Label2, Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import Pill from "@irati/ui/src/Pill";
import Flex from "@irati/ui/src/Flex";
import authentication from "@irati/auth";
import teamService from "@irati/identity/services/teams";
import userService from "@irati/identity/services/users";
import { Table } from "../styled";
import InvitePeople from "./InvitePeople";
var PeopleList = /** @class */ (function (_super) {
    __extends(PeopleList, _super);
    function PeopleList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            users: [],
            teams: [],
            page: 1,
            usersCount: 0
        };
        _this.isLoadingUsers = false;
        _this.getMoreUsers = function () {
            var _a = _this.state, page = _a.page, users = _a.users;
            if (!_this.isLoadingUsers) {
                var newPage = page + 1;
                _this.getUserList(users, newPage);
            }
        };
        _this.getUserList = function (users, page) {
            if (users === void 0) { users = []; }
            if (page === void 0) { page = 1; }
            _this.isLoadingUsers = true;
            var setOptionsVisibility = _this.props.setOptionsVisibility;
            var params = {
                tenantId: authentication.userTenant().uuid,
                page: page,
                deactivated: null,
                sort: "lastname",
                role: null
            };
            return userService.list(params, { fetchPolicy: "network-only" }).then(function (_a) {
                var results = _a.results, total = _a.total;
                var newUsers = results;
                newUsers.forEach(function (user) {
                    var teamsNamesArray = user.teams.results
                        .filter(function (t) { return t.state === TeamState.Generic; })
                        .map(function (_a) {
                        var public_name = _a.public_name;
                        return public_name;
                    });
                    user.resolvedTeams = teamsNamesArray.join(", ");
                });
                var allUsers = users.concat(newUsers);
                var allNonAdminUsers = allUsers.filter(function (user) { return !isGlobalAdmin(authentication.business(), user); });
                if (allNonAdminUsers.length === 0) {
                    setOptionsVisibility(true);
                }
                else {
                    // else we invited some people, meaning options should stay hidden and step completable
                    _this.props.setIsStepCompletable(true);
                }
                _this.setState({
                    users: allUsers,
                    usersCount: total
                });
                _this.isLoadingUsers = false;
            });
        };
        _this.startInviting = function () {
            _this.props.setOptionsVisibility(false);
            _this.setState({ isInviting: true });
        };
        _this.onCallback = function () {
            _this.getUserList();
            _this.setState({ isInviting: false });
        };
        return _this;
    }
    PeopleList.prototype.componentDidMount = function () {
        var _this = this;
        var loadingUsers = teamService.list(authentication.userTenant().uuid, {}, { fetchPolicy: "network-only" }).then(function (teams) {
            _this.setState({ teams: teams });
            return _this.getUserList();
        });
        this.setState({ loadingUsers: loadingUsers });
    };
    PeopleList.prototype.render = function () {
        var _a = this.state, isInviting = _a.isInviting, loadingUsers = _a.loadingUsers, users = _a.users, teams = _a.teams, usersCount = _a.usersCount;
        // TODO amend this when we'll add the funtionality "Invite another Admin", logic TBD
        var firstTimeInvitingPeople = users.length === 1;
        if (isInviting) {
            return React.createElement(InvitePeople, { onCallback: this.onCallback, teams: teams });
        }
        return (React.createElement(Loading, { load: loadingUsers },
            React.createElement(Flex, { justifyContent: "space-between" },
                React.createElement(H3, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.title" }),
                    React.createElement(Pill, { text: React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.pill", values: { count: usersCount } }), margin: "0 15px" })),
                React.createElement(Button, { primary: true, onClick: this.startInviting }, firstTimeInvitingPeople ? (React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.ctaInvite" })) : (React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.ctaInviteMore" })))),
            !firstTimeInvitingPeople && (React.createElement(Para, null,
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.description" }))),
            React.createElement(Table, null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            React.createElement(Label2, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "platform.fields.firstName.label" }))),
                        React.createElement("th", null,
                            React.createElement(Label2, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "platform.fields.lastName.label" }))),
                        React.createElement("th", null,
                            React.createElement(Label2, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "platform.fields.email.label" }))),
                        React.createElement("th", null,
                            React.createElement(Label2, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "platform.fields.teams.label" }))),
                        React.createElement("th", null,
                            React.createElement(Label2, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "platform.fields.accessLevel.label" }))))),
                React.createElement("tbody", null, users.map(function (user) { return (React.createElement("tr", { key: user.uuid },
                    React.createElement("td", null, user.firstname),
                    React.createElement("td", null, user.lastname),
                    React.createElement("td", null, user.email),
                    React.createElement("td", null, user.resolvedTeams),
                    React.createElement("td", null, user.role))); }))),
            users.length < usersCount && (React.createElement(Flex, { justifyContent: "space-around" },
                React.createElement(Button, { onClick: this.getMoreUsers },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.peopleList.loadMore" }))))));
    };
    return PeopleList;
}(Component));
export default PeopleList;
